import { render, staticRenderFns } from "./TaskList.vue?vue&type=template&id=4b8e9b2c&scoped=true&"
import script from "./TaskList.vue?vue&type=script&lang=js&"
export * from "./TaskList.vue?vue&type=script&lang=js&"
import style0 from "./TaskList.vue?vue&type=style&index=0&id=4b8e9b2c&lang=scss&scoped=true&"
import style1 from "./TaskList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b8e9b2c",
  null
  
)

export default component.exports